export enum MultilingualDashboardUrlPath {
  MANAGE_LANGUAGES = 'wix-multilingual/manage-languages',
  TRANSLATION_MANAGER = 'wix-multilingual',
  SETTINGS = 'wix-multilingual/settings',
  ONBOARDING = 'wix-multilingual/onboarding',
  PACKAGE_PICKER = 'wix-multilingual/package-picker',
}
